import { Horizontal, Texto, addCommasToNumber } from '@gravitate-js/excalibrr'
import type { GroupCellRendererParams } from 'ag-grid-community'
import { formatDuration, getTimeVariance, getTotalVariance } from '../util'

export function ProductGroupRowRenderer(props: GroupCellRendererParams) {
  const details = props.node.allLeafChildren?.map((child) => child.data) || []
  const variance = getTotalVariance(details)
  const timeVariance = getTimeVariance(details)
  return (
    <Horizontal verticalCenter justifyContent='space-between' height='100%' style={{ backgroundColor: 'var(--bg-2)' }}>
      <Texto>{props.value}</Texto>
      <Horizontal>
        {!!timeVariance && <Texto className='mr-4'>Time Variance: {formatDuration(timeVariance)}</Texto>}
        {!!variance && <Texto>Vol. Variance: {addCommasToNumber(Math.abs(variance))}</Texto>}
      </Horizontal>
    </Horizontal>
  )
}
